import { ArrayOps, ObjectOps } from '../lift';
/**
* Creates an object composed of keys generated from the results of running each element through a discriminator function.
* The corresponding value of each key is an array of the elements responsible for generating the key.
*/
export function groupBy(discriminator) {
    var arr = this.value(), groups = {};
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        var key = discriminator(item, i);
        if (!groups[key])
            groups[key] = [];
        groups[key].push(item);
    }
    return new ObjectOps(groups);
}
ArrayOps.prototype.groupBy = groupBy;
